var map = {
	"./en.json": [
		1193,
		106
	],
	"./es-cl.json": [
		1194,
		107
	],
	"./es-mx.json": [
		1195,
		109
	],
	"./es-pe.json": [
		1196,
		110
	],
	"./es.json": [
		1197,
		108
	],
	"./pt.json": [
		1198,
		111
	],
	"./widgets/en.json": [
		877,
		8
	],
	"./widgets/es-cl.json": [
		878,
		9
	],
	"./widgets/es-mx.json": [
		879,
		11
	],
	"./widgets/es-pe.json": [
		880,
		12
	],
	"./widgets/es.json": [
		881,
		10
	],
	"./widgets/pt.json": [
		882,
		13
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 771;
module.exports = webpackAsyncContext;